import React from 'react';

const Input = ({ name, label, placeholder, autofocus, error, ...rest }) => {
  return (
    <div className="form-group">
      <div className="form-label-group">
        <label
          style={{
            display: 'block',
            color: 'black',
            fontWeight: 'bold',
            fontSize: 12 + 'px'
          }}
          htmlFor={name}
        >
          {label}
        </label>
        <input
          {...rest}
          name={name}
          id={name}
          className="form-control"
          style={{ borderRadius: 0 }}
          placeholder={placeholder}
          autoFocus={autofocus}
        />
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    </div>
  );
};

export default Input;
